/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {WarningsEnum} from '../warnings.enum';

@Component({
    selector: 'app-warning-star',
    templateUrl: './warning-star.component.html',
    styleUrls: [
        './warning-star.component.css',
        '../warnings.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WarningStarComponent implements OnInit {

    @Input() type: WarningsEnum = WarningsEnum.WARNING;

    constructor() {
    }

    ngOnInit(): void {
    }

    setTooltipText(): string {
        switch (this.type) {
            case WarningsEnum.WARNING:
                return 'Required for save and send';
                break;
            case WarningsEnum.WARNING_PNC_SEND:
            case WarningsEnum.INFO:
                return 'Required for send';
                break;
            case WarningsEnum.WARNING_SAVE:
                return 'Required for save';
                break;
            case WarningsEnum.WARNING_CREATE:
                return 'Required to create';
                break;
            case WarningsEnum.WARNING_APPLY:
                return 'Required to apply';
                break;
            default:
                return 'Required for save and send';
        }
    }

    setCssClass(): string {
        let colorClass;
        switch (this.type) {
            case WarningsEnum.WARNING_PNC_SEND:
            case WarningsEnum.WARNING:
                colorClass = 'warning';
                break;
            case WarningsEnum.INFO:
                colorClass = 'info';
                break;
            default:
                colorClass = 'warning';
        }
        return `warning-star ${colorClass}`;
    }

}
